import { render } from "./Tal_formDotLine.vue?vue&type=template&id=c2a7c224&scoped=true"
import script from "./Tal_formDotLine.vue?vue&type=script&lang=js"
export * from "./Tal_formDotLine.vue?vue&type=script&lang=js"

import "./Tal_formDotLine.vue?vue&type=style&index=0&id=c2a7c224&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a7c224"]])

export default __exports__